import { WS_RepairMessage } from './repair-messages';

export enum ActionCableChannel {
  RepairMessageChannel = 'RepairMessageChannel',
}

// type of websocket data based on ActionCableChannel
export type ActionCableChannelType<T> =
  T extends ActionCableChannel.RepairMessageChannel ? WS_RepairMessage : never;
